import { ChatMessage, ChatMessageType, ChatParticipant } from "@/types/chatwidget";

const demoContent: { messageList: ChatMessage[], participants: ChatParticipant[] } = {
  messageList: [
    {
      id: 'message1',
      author: 'me',
      data: {
        text: 'Hello World'
      },
      timestamp: 100000000000,
      type: ChatMessageType.Text,
      user: 'user1'
    },
    {
      id: 'message2',
      author: 'user2',
      data: {
        text: 'Hi'
      },
      timestamp: 100000000000,
      type: ChatMessageType.Text,
      user: 'user2'
    },
    {
      id: 'message3',
      author: 'me',
      data: {
        file: {
          url: 'https://firebasestorage.googleapis.com/v0/b/cloudcast-dev.appspot.com/o/widget%2Fchat%2FSypvYrL4UHz0AyGgxKHl%2F1571821299884?alt=media&token=22ffd98c-6821-4235-b49e-dae13150d4b7'
        }
      },
      timestamp: 100000000000,
      type: ChatMessageType.File,
      user: 'user3'
    },
    {
      id: 'message4',
      author: 'user4',
      data: {
        emoji: '😊'
      },
      timestamp: 100000000000,
      type: ChatMessageType.Emoji,
      user: 'user4'
    }
  ],
  participants: [
    {
      id: 'user1',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/cloudcast-prod.appspot.com/o/avatars%2Favatar1.svg?alt=media&token=d29d26fe-e618-47a3-9131-b682d4ae9633',
      initials: 'U1',
      name: 'User 1'
    },
    {
      id: 'user2',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/cloudcast-prod.appspot.com/o/avatars%2Favatar2.svg?alt=media&token=57474cda-db7f-4c7c-a59b-0b5cce15cc32',
      initials: 'U2',
      name: 'User 2'
    },
    {
      id: 'user3',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/cloudcast-prod.appspot.com/o/avatars%2Favatar3.svg?alt=media&token=9d013223-d142-41db-8e04-db30a3580519',
      initials: 'U3',
      name: 'User 3'
    },
    {
      id: 'user4',
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/cloudcast-prod.appspot.com/o/avatars%2Favatar4.svg?alt=media&token=cd109fcc-e810-4966-ad4c-82b86c58cbab',
      initials: 'U4',
      name: 'User 4'
    }
  ]
}

export default demoContent
